import { Navigate, useParams } from 'react-router-dom'

import AddLiquidityFewToken from './index'

export function RedirectDuplicateTokenIdsFewToken() {
  const { currencyIdA, currencyIdB } = useParams<{ currencyIdA: string; currencyIdB: string }>()

  if (currencyIdA && currencyIdB && currencyIdA.toLowerCase() === currencyIdB.toLowerCase()) {
    return <Navigate to={`/add/fewtoken/${currencyIdA}`} replace />
  }

  return <AddLiquidityFewToken />
}
